import React from "react";
import ExplorePageDetails from "./ExplorePageDetails";

const ManageExplorePage = () => {
  return <ExplorePageDetails />;
};

export default ManageExplorePage;
